import { Fragment } from 'react'

const TextWithLineBreaks = ({ text }: { text: string }) => {
  const lines = text.split('\n')
  return (
    <>
      {lines.map((line, i, arr) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={i}>
          {line}
          {i < arr.length - 1 && <br />}
        </Fragment>
      ))}
    </>
  )
}

export default TextWithLineBreaks
